import api from '.';

export function listar({ start = 0, size = 10, filters = '[]', filtersMode = '{}', globalFilter = '', sorting = '[]' } = {}) {
    return api.get('/associadoVinculo/listar', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
        },
    });
}

export function consultar(uuid) {
    return api.get(`/associadoVinculo/editar/${uuid}`);
}

export function cadastrar(dados) {
    return api.post('/associadoVinculo/cadastrar', dados);
}

export function editar(uuid, dados) {
    return api.post('/associadoVinculo/editar', {
        ...dados,
        uuid,
    });
}

export function excluir(uuid) {
    return api.post('/associadoVinculo/deletar', {
        id: uuid,
    });
}

export function imprimir(url, obj = {}) {
    return api.post(`/associadoVinculo/imprimir/?${url.toString()}`, obj, { responseType: 'arraybuffer' });
}

export function ficha(uuid, { dataReferencia } = {}) {
    return api.get(`/associadoVinculo/${uuid}/ficha`, {
        params: dataReferencia ? { dataReferencia } : {},
        responseType: 'arraybuffer',
    });
}
